import { AnalyticsBrowser } from '@segment/analytics-next'

import { segmentMiddleware } from 'utils/segmentMiddleware'
import { URL_OF_CUSTOM_PROXY_FOR_SEGMENT_CDN } from './constants'

const writeKey = process.env.SEGMENT_WRITE_KEY

if (!writeKey) {
  throw new Error(
    `Unable to initialize Segment analytics: SEGMENT_WRITE_KEY not found`,
  )
}

const initializeSegmentAnalytics = (): AnalyticsBrowser => {
  const segmentAnalytics = AnalyticsBrowser.load({
    writeKey,
    cdnURL: URL_OF_CUSTOM_PROXY_FOR_SEGMENT_CDN,
  })

  segmentAnalytics.addSourceMiddleware(segmentMiddleware)

  return segmentAnalytics
}

export const segmentAnalytics: AnalyticsBrowser = initializeSegmentAnalytics()
